import { graphql, useStaticQuery } from 'gatsby'
import { DetailedHTMLProps, MetaHTMLAttributes, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'

interface HeadProps {
  description?: string
  lang?: string
  meta?: DetailedHTMLProps<MetaHTMLAttributes<HTMLMetaElement>, HTMLMetaElement>[]
  keywords?: string[]
  title: string
}

const Head = ({ description, lang = 'en', meta = [], keywords = [], title }: HeadProps) => {
  const data = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `)

  const metaDescription = useMemo(
    () => description || data.site.siteMetadata.description,
    [data.site.siteMetadata.description, description],
  )

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={`%s | ${data.site.siteMetadata.title}`}
      meta={[
        ...[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: 'google-site-verification',
            content: process.env.GATSBY_GOOGLE_SEARCH_CONSOLE,
          },
          {
            name: 'naver-site-verification',
            content: process.env.GATSBY_NAVER_SEARCH_ADVISOR,
          },
        ].concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : [],
        ),
        ...meta,
      ]}
    />
  )
}

export default Head
